import React, { useEffect, useRef } from 'react';
import { preloadImages, debounce } from '../utils/utils';

const SugestedCanvasRenderer = ({ imageGroup, index, title, width, height, originalHeight, originalWidth, imageMeasureUnit, marginCheck, marginValue }) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const createCanvases = async () => {
      const container = containerRef.current;
      const canvas = canvasRef.current;
      if (!canvas || !container) return;

      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;
      let loadedImages = await preloadImages(imageGroup);

      const scaleWidth = containerWidth / width;
      const scaleHeight = containerHeight / height;
      const scale = Math.min(scaleWidth, scaleHeight, 1);

      canvas.width = Math.floor(width * scale);
      canvas.height = Math.floor(height * scale);
      canvas.style.maxWidth = '100%';
      canvas.style.maxHeight = '100%';
      canvas.style.display = 'block';
      canvas.style.margin = '0 auto';
      canvas.style.border = '2px solid #FF5733';

      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#E8F4FC';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.scale(scale, scale);

      let margin;
      if (imageMeasureUnit === 'in' && marginCheck) {
        margin = marginValue * 300;
      } else if (marginCheck) {
        margin = (marginValue * 300) / 2.54;
      } else {
        margin = 0;
      }

      loadedImages.forEach(({ img, item }) => {
        const x = item.x;
        const y = item.y;
        const w = item.width - margin;
        const h = item.height - margin;
        if (item.rotated) {
          ctx.save();
          ctx.translate(x + w / 2, y + h / 2);
          ctx.rotate(Math.PI / 2);
          ctx.drawImage(img, -h / 2, -w / 2, h, w);
          ctx.restore();
        } else {
          ctx.drawImage(img, x, y, w, h);
        }
      });
    };

    createCanvases();
    const handleResize = debounce(() => createCanvases(), 250);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [imageGroup, width, height, imageMeasureUnit, marginCheck, marginValue]);

  return (
    <div className="apply-cardcontent">
      <div className="apply-imgDiv"
        ref={containerRef}
        style={{
          height: "248px",
          width: "100%",
          position: "relative",
          backgroundColor: "rgb(215 215 212)",
          border: "1px dashed #3498DB",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px"
        }}>
        <canvas ref={canvasRef}></canvas>
      </div>
    </div>
  );
};

export default SugestedCanvasRenderer;
